import React from "react";
import * as Styled from "./SelectTemplate.styled";
import { getLayoutImage, LayoutImages, LayoutTemplates, BlockLayoutSupport, BlockType } from "../../../libs";
import { Pencil, ArrowLeft } from "react-bootstrap-icons";

interface SelectTemplateProps {
    show: boolean;
    template: number;
    blockType: BlockType;
    onTemplateChange: (templateId: number) => void;
}  



export const SelectTemplate: React.FC<SelectTemplateProps> = ({ show, template, blockType,onTemplateChange }) => {
    const [editTemplate, setEditTemplate] = React.useState(false);

    return (
        <Styled.SelectTemplateContainer $isVisible={show}>
            <Styled.SelectTemplateContainerHeader>
                Template
            </Styled.SelectTemplateContainerHeader>
            <Styled.CardView $isVisible={!editTemplate}>
                <Styled.TemplateCard
                    src={getLayoutImage(template as LayoutTemplates)}
                    rounded
                />
                <Styled.CustomButton variant="outline-secondary" onClick={() => setEditTemplate(true)}>
                    <Styled.IconWrapper>
                        <Pencil size={16} />
                    </Styled.IconWrapper>
                    <Styled.Label>Edit Template</Styled.Label>
                </Styled.CustomButton>
            </Styled.CardView>
            
            <Styled.GridView $isVisible={editTemplate}>
                <Styled.BackButton onClick={() => setEditTemplate(false)}>
                    <ArrowLeft size={20} />
                    <span>Back</span>
                </Styled.BackButton>
                <Styled.SelectTemplateGrid>
                    {
                        Object.entries(LayoutImages).map(([key, value]) => {
                            if (!BlockLayoutSupport[blockType].includes(Number(key))) {
                                return null; // Skip unsupported templates
                            }
                            return (
                                <Styled.SelectTemplateItem
                                    key={key}
                                    src={value}
                                    rounded
                                    onClick={() => onTemplateChange(Number(key))}
                                    $isSelected={template === Number(key)}
                                />
                            )
                        })
                    }
                </Styled.SelectTemplateGrid>
            </Styled.GridView>
        </Styled.SelectTemplateContainer>
    )
};